// extracted by mini-css-extract-plugin
module.exports = {"ProductHeaderEditoImage":"styles_ProductHeaderEditoImage__f547U","ratio":"styles_ratio__w8oBS"};